export default "<div class=\"timer\">\n  <p>{{ 'widget.reservation.timeLeftForPayment' | translate }} {{ formattedTime }}</p>\n</div>\n"